import React, { useState, useEffect } from 'react';
import { TextField, Box, CircularProgress } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { format, startOfToday, startOfMonth } from 'date-fns';
import { de } from 'date-fns/locale';

export default function DateSelection({
  tenantId,
  selectedDate,
  setSelectedDate,
  availableDays,
  fetchAvailableDaysForDisplayedMonth,
  selectedEmployee,
  selectedAppointmentType,
  appointmentTypes,
  employees,
}) {
  const [loadingMonth, setLoadingMonth] = useState(false);

  // Falls man in Step0 etwas ändert
  useEffect(() => {
    if (!selectedEmployee || !selectedAppointmentType) {
      setSelectedDate(null);
      return;
    }

    // Hier sorgen wir dafür, dass direkt einmal fetchAvailableDaysForDisplayedMonth 
    // für den "aktuellen" Monat aufgerufen wird, sofern 
    // Employee & Terminart gesetzt sind.
    const initialMonth = selectedDate || new Date(); 
    // oder startOfMonth(new Date()) falls du immer vom Monatsanfang ausgehst

    setLoadingMonth(true);
    fetchAvailableDaysForDisplayedMonth(initialMonth)
      .finally(() => setLoadingMonth(false));
  }, [selectedEmployee, selectedAppointmentType]);

  // Diese Funktion wird aufgerufen, wenn man manuell den Monat ändert
  const handleMonthChange = async (newMonthDate) => {
    setLoadingMonth(true);
    try {
      await fetchAvailableDaysForDisplayedMonth(newMonthDate);
    } finally {
      setLoadingMonth(false);
    }
  };

  const isDayAvailable = (day) => {
    const dayStr = format(day, 'yyyy-MM-dd');
    return availableDays.includes(dayStr);
  };

  return (
    <Box sx={{ mb: 3 }}>
      {loadingMonth && (
        <Box display="flex" alignItems="center" mb={1}>
          <CircularProgress size={24} />
          {/* <Box ml={2}>Lade verfügbare Tage ...</Box> */}
        </Box>
      )}

      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
        <DesktopDatePicker
          label="Datum wählen"
          value={selectedDate}
          onChange={(newValue) => setSelectedDate(newValue)}
          minDate={startOfToday()}
          shouldDisableDate={(day) => !isDayAvailable(day)}
          onMonthChange={handleMonthChange}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      </LocalizationProvider>
    </Box>
  );
}
